export default __webpack_public_path__ + "static/media/andada.9cee7360.otf";